import React, {useState, useEffect, useRef} from 'react'
import {Box, Button} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import useTagManager from '../../hooks/use-tag-manager'

export const TruncatedText = ({textValue, product, isPanelExpanded, linesToShow = 3, ...rest}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const [isTruncated, setIsTruncated] = useState(false)
    const textRef = useRef(null)
    const tagManager = useTagManager()
    const [isIOS15, setIsIOS15] = useState(false)
    const intl = useIntl()

    useEffect(() => {
        if (isPanelExpanded) {
            setTimeout(() => {
                if (textRef.current) {
                    const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight)
                    const maxHeight = lineHeight * (linesToShow + 1)
                    setIsTruncated(textRef.current.scrollHeight >= maxHeight)
                }
            }, 200)
        }
    }, [isPanelExpanded, textValue, textRef?.current?.scrollHeight])

    useEffect(() => {
        const validation = (() => {
            if (typeof navigator === 'undefined') return false

            const isIOS =
                /iP(hone|od|ad)/.test(navigator.platform) ||
                (navigator.userAgent.includes('Mac') && 'ontouchend' in document)

            if (!isIOS) return false

            const match = navigator.userAgent.match(/OS (\d+)_/)
            if (match) {
                const version = parseInt(match[1], 10)
                return version <= 15
            }

            return false
        })()

        setIsIOS15(validation)
    }, [])

    return !textValue ? (
        <></>
    ) : (
        <Box {...rest}>
            <Box
                ref={textRef}
                noOfLines={isExpanded ? undefined : isIOS15 ? undefined : linesToShow}
                dangerouslySetInnerHTML={{
                    __html: textValue
                }}
                {...rest}
            />
            {isTruncated && (
                <Button
                    color="black.100"
                    _active={{color: 'black.100'}}
                    textDecoration="underline"
                    textUnderlineOffset="4px"
                    fontSize="14px"
                    variant="link"
                    marginTop="10px"
                    onClick={() => {
                        setIsExpanded(!isExpanded)
                        tagManager.pdpCtaClick(
                            !isExpanded ? 'cta click - Read More' : 'cta click - Read Less',
                            product?.name
                        )
                    }}
                >
                    {isExpanded
                        ? intl.formatMessage({
                              id: 'read.less',
                              defaultMessage: 'Read Less'
                          })
                        : intl.formatMessage({
                              id: 'read.more',
                              defaultMessage: 'Read More'
                          })}
                </Button>
            )}
        </Box>
    )
}

TruncatedText.displayName = 'TruncatedText'

TruncatedText.propTypes = {
    textValue: PropTypes.string,
    product: PropTypes.shape({
        name: PropTypes.string
    }),
    isPanelExpanded: PropTypes.bool,
    linesToShow: PropTypes.number
}

export default TruncatedText
